import { Card, CardContent, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts";

type ScoreCardProps = {
  title: string;
  count: number;
  quantity: number;
  color?: string;
  claimed: number;
  consumed: number;
};
type Row = { id: number; value: number; label: string };

export const ScoreCard = ({
  title,
  count,
  quantity,
  color = "#6C0088",
  claimed,
  consumed,
}: ScoreCardProps) => {
  const rows: Row[] = [
    { id: 1, value: claimed, label: "Réclamés" },
    { id: 2, value: consumed, label: "Consumés" },
    { id: 3, value: quantity - consumed, label: "Restants" },
  ];
  const labels = rows.map((r) => r.label);
  const COLORS = ["#0984E3", "#00B894", "#E17055"];

  const ratioLabel = (_count: number, _quantity: number): string => {
    return `Nombre ${_count ?? 0} pour ${_quantity ?? 0} unités.`;
  };

  return (
    <Card
      sx={{ borderLeft: `5px solid ${color}`, boxShadow: 2, borderRadius: 2 }}
    >
      <CardContent>
        <Typography variant="h6" color="textSecondary" gutterBottom>
          {title.toUpperCase()}
        </Typography>
        <Typography color={color}>{ratioLabel(count, quantity)}</Typography>
      </CardContent>
      <BarChart
        xAxis={[
          {
            scaleType: "band",
            data: labels,
            colorMap: {
              type: "ordinal",
              values: labels,
              colors: COLORS,
            },
          },
        ]}
        yAxis={[{ min: 0 }]}
        series={[{ data: rows.map((r) => r.value) }]}
        barLabel="value"
        grid={{ horizontal: true }}
      />
    </Card>
  );
};
